import { render } from "./admin.vue?vue&type=template&id=4c699911&scoped=true"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"

import "./admin.vue?vue&type=style&index=0&id=4c699911&lang=less&scoped=true"

import exportComponent from "E:\\MySite\\XuDAQMS\\xudaqms-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c699911"]])

export default __exports__